export function linkWebAccessibilty() {
  /*Add 'noopener noreferrer' to links opening in a new tab*/
  function addNoOpener(link) {
    let linkTypes = (link.getAttribute('rel') || '').split(' ');
    if (!linkTypes.includes('noopener')) {
      linkTypes.push('noopener noreferrer');
    }else if(linkTypes.includes('noopener') && !linkTypes.includes('noreferrer')){
      linkTypes.push('noreferrer');
    }
    link.setAttribute('rel', linkTypes.join(' ').trim());
  }
    /*Add acreen reader text to links opening in a new tab*/
  function addNewTabMessage(link) {
    if (!link.querySelector('.screen-reader-text')) {
      link.insertAdjacentHTML('beforeend', '<span class="screen-reader-text">('+webAccessibilityText.linkScreenReaderText+')</span>');
    }
  }


  /*Add aria-label attribute to links opening in a new tab*/
  function addAriaLabel(link) {
    if (!link.hasAttribute("aria-label")) {
      link.setAttribute('aria-label', webAccessibilityText.linkArialabel);
    }
  }


  /*Open external links in a new tab*/
  window.addEventListener("DOMContentLoaded", function externalLinks() {
    var anchors = document.querySelectorAll('a[href]:not([data-target="self"])');
    for (var i = 0; i < anchors.length; i++) {
      if (anchors[i].hostname !== window.location.hostname) {
        anchors[i].setAttribute("target", "_blank");
        addNoOpener(anchors[i]);
        addNewTabMessage(anchors[i]);
        addAriaLabel(anchors[i]);
      }
    }
  });


  document.querySelectorAll('a[target="_blank"]').forEach(link => {
    addNoOpener(link);
    addNewTabMessage(link);
    addAriaLabel(link);
  });
}
